import React from 'react';
import { AlertDialog } from '@lumx/react';

interface Props {
  isOpen: boolean;
  nodeName: string;
  descendantCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConvertToLocationDialog: React.FC<Props> = ({
  isOpen, nodeName, descendantCount, onConfirm, onCancel,
}) => (
  <AlertDialog
    isOpen={isOpen}
    onClose={onCancel}
    kind="warning"
    title={`Convert "${nodeName}" to a Location?`}
    confirmProps={{ label: 'Convert to Location', onClick: onConfirm }}
    cancelProps={{ label: 'Cancel', onClick: onCancel }}
  >
    <p style={{ fontSize: 14, color: 'var(--color-dark-l1)', lineHeight: 1.6 }}>
      Locations cannot have sub-units.{' '}
      <strong>
        {descendantCount} nested unit{descendantCount !== 1 ? 's' : ''} will be permanently deleted.
      </strong>
    </p>
    <p style={{ marginTop: 10, fontSize: 14, color: 'var(--color-dark-l1)', lineHeight: 1.6 }}>
      Any sites mapped to deleted units will become not mapped. This action cannot be undone.
    </p>
  </AlertDialog>
);

export default ConvertToLocationDialog;
